// extracted by mini-css-extract-plugin
export default {"diffStatesWrapper":"PullRequestHeader-module__diffStatesWrapper--i4iJ1","PreviewLabel":"PullRequestHeader-module__PreviewLabel--ZbqiN"};